import { defineNuxtPlugin } from '#imports'
import type { ParameterizedMessageObject } from 'elastic-apm-node'
import logger from '@/app/utils/logger/logger'

export default defineNuxtPlugin({
  name: 'vue error handler',
  enforce: 'pre',
  parallel: true,
  async setup(nuxtApp) {
    if (import.meta.dev) return

    nuxtApp.hook('vue:error', (err: unknown) => {
      if (import.meta.server)
        import('elastic-apm-node').then(({ default: apm }) => {
          const error = err as string | Error | ParameterizedMessageObject
          if (apm?.isStarted()) apm?.captureError(error)
        })

      logger.error(err, 'vue:error')
    })

    nuxtApp.hook('app:error', (err: string) => {
      if (import.meta.server)
        import('elastic-apm-node').then(({ default: apm }) => {
          if (apm?.isStarted()) apm?.captureError(err)
        })

      logger.error(err, 'app:error')
    })

    /* eslint-disable-next-line no-param-reassign */
    nuxtApp.vueApp.config.errorHandler = (err: unknown) => {
      if (import.meta.server)
        import('elastic-apm-node').then(({ default: apm }) => {
          const error = err as string | Error | ParameterizedMessageObject
          if (apm?.isStarted()) apm?.captureError(error)
        })

      logger.error(err, 'vueApp.config')
    }

    /* eslint-disable-next-line no-param-reassign */
    nuxtApp.vueApp.config.warnHandler = (err: string) => {
      if (import.meta.server)
        import('elastic-apm-node').then(({ default: apm }) => {
          if (apm?.isStarted()) apm?.captureError(err)
        })

      logger.warn(err, 'vueApp.config')
    }
  },
})
